import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';

import { publicEnv } from '@/lib/env';

const DASHBOARD_ILLUSTRATION_BASE = `${publicEnv.NEXT_PUBLIC_IMAGE_CDN_URL}/global`;
const EMPTY_STATE_ILLUSTRATION_BASE = `${DASHBOARD_ILLUSTRATION_BASE}/player-dashboard/empty-states`;
const GEAR_ILLUSTRATION_BASE = `${DASHBOARD_ILLUSTRATION_BASE}/player-dashboard/gear`;
const FRIENDS_FOLLOWING_ILLUSTRATION_BASE = `${DASHBOARD_ILLUSTRATION_BASE}/player-dashboard/friends-following`;

export const DASHBOARD_ILLUSTRATION = {
  MASCOT_SUCCESS: getCDNURL(`${DASHBOARD_ILLUSTRATION_BASE}/PB-mascot-success.svg`, 100, 117),
  MASCOT_RUNNING: getCDNURL(`${DASHBOARD_ILLUSTRATION_BASE}/PB-mascot-running.svg`, 84, 119),
  MASCOT_RUNNING_PADDLE: getCDNURL(
    `${DASHBOARD_ILLUSTRATION_BASE}/PB-mascot-running-paddle.svg`,
    95,
    118
  ),
  MASCOT_PLAY: getCDNURL(`${DASHBOARD_ILLUSTRATION_BASE}/PB-mascot-play.svg`, 125, 104),
  MASCOT_WAVING_BAG: getCDNURL(`${DASHBOARD_ILLUSTRATION_BASE}/PB-mascot-waving-bag.svg`, 100, 140),
  MASCOT_JUMPING: getCDNURL(`${EMPTY_STATE_ILLUSTRATION_BASE}/PB-mascot-jumping.svg`, 120, 135),
  MASCOT_CELEBRATING: getCDNURL(
    `${EMPTY_STATE_ILLUSTRATION_BASE}/PB-mascot-celebrating.svg`,
    120,
    150
  ),
  MASCOT_PADDLE: getCDNURL(`${EMPTY_STATE_ILLUSTRATION_BASE}/PB-mascot-paddle.svg`, 190, 185),
  MASCOT_CROWN: getCDNURL(`${EMPTY_STATE_ILLUSTRATION_BASE}/PB-mascot-crown.svg`, 160, 133),
  MASCOT_PHONE: getCDNURL(`${FRIENDS_FOLLOWING_ILLUSTRATION_BASE}/login.svg`, 120, 110),
  MASCOT_DUO: getCDNURL(`${FRIENDS_FOLLOWING_ILLUSTRATION_BASE}/duo.svg`, 180, 128),
  MASCOT_INVITES: getCDNURL(`${FRIENDS_FOLLOWING_ILLUSTRATION_BASE}/invites.svg`, 120, 104),
  MASCOT_SHADES_PADDLE: getCDNURL(
    `${FRIENDS_FOLLOWING_ILLUSTRATION_BASE}/empty-state.svg`,
    147,
    108
  ),
  MASCOT_LOUNGE: getCDNURL(`${FRIENDS_FOLLOWING_ILLUSTRATION_BASE}/empty-state-alt.svg`, 180, 128),
  MASCOT_FLEXING: getCDNURL(`${FRIENDS_FOLLOWING_ILLUSTRATION_BASE}/strong-mascot.svg`, 187, 142),
  MASCOT_NETS: getCDNURL(`${GEAR_ILLUSTRATION_BASE}/Mascot_Nets.svg`, 220, 156),
  PODIUM: getCDNURL(`${EMPTY_STATE_ILLUSTRATION_BASE}/PB-podium.svg`, 180, 96),
  PLANET: getCDNURL(`${EMPTY_STATE_ILLUSTRATION_BASE}/PB-planet.svg`, 107, 69),
  BALL: getCDNURL(`${EMPTY_STATE_ILLUSTRATION_BASE}/PB-ball.svg`, 40, 42),
  UFO_MASCOT: getCDNURL(
    `${DASHBOARD_ILLUSTRATION_BASE}/empty-dataset/empty-dataset-alt-4.svg`,
    282,
    200
  ),
} as const;
